const logtoStorageItemKeyPrefix = `logto`;
class BrowserStorage {
    constructor(appId) {
        this.storageKey = `${logtoStorageItemKeyPrefix}:${appId}`;
    }
    async getItem(key) {
        if (key === 'signInSession') {
            return sessionStorage.getItem(this.storageKey);
        }
        return localStorage.getItem(`${this.storageKey}:${key}`);
    }
    async setItem(key, value) {
        if (key === 'signInSession') {
            sessionStorage.setItem(this.storageKey, value);
            return;
        }
        localStorage.setItem(`${this.storageKey}:${key}`, value);
    }
    async removeItem(key) {
        if (key === 'signInSession') {
            sessionStorage.removeItem(this.storageKey);
            return;
        }
        localStorage.removeItem(`${this.storageKey}:${key}`);
    }
}

export { BrowserStorage, logtoStorageItemKeyPrefix };
